import { Observable } from 'rxjs';
import { MenuSection } from './const/enum';

export type MenuDef = {
  caption: string;
  href: string;
  label?: Observable<string>;
};

export class SidebarItemDefinition {
  constructor(
    public readonly header: string,
    public readonly href: string,
    public readonly icon: string,
    public readonly section: MenuSection,
    menuDefinition?: MenuDef[]
  ) {
    this.menuDefinition = menuDefinition || [];
    this.routerLink = this.href?.startsWith('https://') ? '' : this.href || '';
  }
  routerLink: string;

  updates: number;
  hasUnreadMessages: boolean;
  expanded: boolean = false;

  readonly menuDefinition: MenuDef[];

  get hasMenu(): boolean {
    return this.menuDefinition?.length > 0;
  }
}
